import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

// Shown on every page except Home. Goes back if the visitor came from inside
// the site, otherwise to a sensible parent page.
const BackButton = () => {
  const { pathname, key } = useLocation();
  const navigate = useNavigate();
  if (pathname === '/' || pathname === '/admin') return null;

  const fallback = pathname.startsWith('/product/') ? '/shop' : pathname.startsWith('/admin') ? '/admin' : '/';
  const handleBack = () => {
    // key === 'default' means this is the first page opened in this tab.
    if (key !== 'default' && window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-[76px] -mb-20 relative z-30">
      <button
        type="button"
        onClick={handleBack}
        className="inline-flex items-center gap-2 text-sm font-medium text-foreground/80 hover:text-foreground bg-secondary/80 hover:bg-secondary border border-border/40 rounded-sm px-3 py-2 transition-colors"
        data-testid="back-button"
        aria-label="Go back"
      >
        <ArrowLeft size={16} weight="bold" />
        Back
      </button>
    </div>
  );
};

export default BackButton;
